var map = {
	"./sms-settings-de.html": 1642,
	"./sms-settings-en.html": 1643,
	"./sms-settings-es.html": 1644,
	"./sms-settings-fr.html": 1645,
	"./sms-settings-ja.html": 1646,
	"./sms-settings-pt.html": 1647,
	"./sms-settings-zh.html": 1648
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1641;


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sms-services/help/sms-settings ^\.\/sms\-settings\-.*\.html$
// module id = 1641
// module chunks = 0